export default {
    CLOSED_AREA_COMMENT: '/cms:area',
    CLOSED_COMPONENT_COMMENT: '/cms:component',
    TEMPLATE_ID_PROP: 'mgnl:template'
};
